import { requestGet } from '@/common/request';

export interface hasRelationParams {
  roomId: string;
  tibaoId: string;
}

export interface hasRelationRes {
  ret: string;
  msg: string;
  data: {
    isRelated: boolean;
  };
}

//会场运营 - 判断会场活动与提报活动是否存在关联关系
export async function hasRelation(params: hasRelationParams): Promise<hasRelationRes> {
  return await requestGet('/room/hasRelation', params);
}
